import classNames from 'classnames';

import { CtfAssetType } from '@/utils/constants';

export const MEDIA_VARIANTS = Object.keys(CtfAssetType);
const CLOUDINARY_BASE = process.env.NEXT_PUBLIC_CLOUDINARY_BASE;
export const CLOUDINARY_VIDEO_TRANSFORMATIONS = {
  // Modern HEVC (Safari / iOS) and VP9 (Chrome / Android) formats
  "hevc_full": "c_scale,q_auto,vc_h265,w_1920,f_mp4",
  "vp9_full": "c_scale,q_auto,vc_vp9,w_1920,f_webm",
  "hevc_half": "c_scale,q_auto,vc_h265,w_1280",
  "vp9_half": "c_scale,q_auto,vc_vp9,w_1280",

  // Backup h264 format (safe for almost all devices in the past 15 years)
  "mp4_low": "c_scale,q_auto,vc_h264,w_1280",

  // Vertical transformations for card and mobile full videos
  "vertical_vp9": "c_fill,ar_9:16,q_auto,w_720,vc_vp9,f_webm",
  "vertical_hevc": "c_fill,ar_9:16,q_auto,w_720,vc_h265,f_mp4",
  "vertical_mp4": "c_fill,ar_9:16,q_auto,w_720,vc_h264,f_mp4", // Older phones (pre iPhone 7 / Android 4.4)
}

export function isVideo(contentType = '') {
  return contentType.startsWith(CtfAssetType.VIDEO);
}

export function isImage(contentType = '') {
  return contentType.startsWith(CtfAssetType.IMAGE);
}

const URL_REGEXP = RegExp(/^\/\//);
export function getHttpsUrl(url) {
  if (!url) return;
  return url.replace(URL_REGEXP, 'https://');
}

export function getImageWrapperClass({ isCta }) {
  return classNames('w-full h-full aaco-media aaco-media--image', {
    'aaco-media--image-with-link': isCta,
  });
}

export function getImageClass({ style, fullSize = true }) {
  return classNames('object-cover', fullSize && 'w-full h-full', style);
}

export function getVideoClass({ style }) {
  return classNames('object-cover w-full h-full ', style);
}

export function hasVideo(assets) {
  if (!assets?.length) return false;
  return assets.some((asset) => isVideo(asset?.file?.contentType) || asset?.resource_type === 'video');
}

export function isVideoWithPoster(assets) {
  if (assets.length !== 2) return false;
  const [asset0, asset1] = assets;
  return (
    isImage(asset0?.file?.contentType) && isVideo(asset1?.file?.contentType)
  );
}

export function getCloudinaryVideoPoster(video) {
  return encodeURI(`${CLOUDINARY_BASE}/video/upload/so_50,q_auto,f_auto/v${video.version}/${video.public_id}.jpg`);
}

export function getCloudinaryVideo(video, format, optimisation = 'q_auto/f_auto') {
  return encodeURI(`${CLOUDINARY_BASE}/video/upload/${optimisation}/v${video.version}/${video.public_id}.${format}`);
}

export function getCloudinaryImage(image, format, optimisation = 'q_auto,f_auto') {
  return encodeURI(`${CLOUDINARY_BASE}/image/upload/${optimisation}/v${image.version}/${image.public_id}.${format}`);
}

export function getCloudinaryCanTransform(video) {
  return video.bytes / (1024 * 1024) < 290;
}
